/**
 * Cuadrilla brandmark — inline SVG reproduction of the real app icon
 * (`mobile/assets/icon.png`) so the web matches the mobile app, the
 * Play Store listing and the landing page exactly.
 *
 * Why inline SVG (not <img src="/logo.png">): the PNG is 1024×1024 and
 * looks blurry/dirty when rendered at chrome sizes (28 px in the
 * sidebar). A vector path scales crisply at every density without
 * shipping multiple raster sources.
 *
 * Brand hex literals (`#1B4F72` navy, `#E8531A` accent, `#FFFFFF`
 * white) are *intentionally* hardcoded here — DESIGN_SYSTEM.md §5
 * marks them as immutable identity colors. They never theme-shift.
 *
 * The `tone` prop is preserved for API stability with earlier
 * callsites but no longer changes rendering — the brandmark is the
 * full-color identity asset.
 */
interface BrandMarkProps {
  size?: number;
  tone?: 'primary' | 'security';
  ariaLabel?: string;
  className?: string;
}

export function BrandMark({
  size = 32,
  tone: _tone,
  ariaLabel,
  className,
}: BrandMarkProps) {
  void _tone;
  const decorative = !ariaLabel;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role={decorative ? 'presentation' : 'img'}
      aria-hidden={decorative ? true : undefined}
      aria-label={decorative ? undefined : ariaLabel}
      focusable="false"
    >
      <rect width="32" height="32" rx="7" fill="#1B4F72" />
      <path
        d="M16 6C10.477 6 6 10.477 6 16s4.477 10 10 10c2.09 0 4.03-.64 5.63-1.73l-1.63-1.63A7.948 7.948 0 0 1 16 24c-4.418 0-8-3.582-8-8s3.582-8 8-8c1.8 0 3.46.596 4.8 1.594l1.62-1.62A9.956 9.956 0 0 0 16 6z"
        fill="#FFFFFF"
      />
      <path
        d="M23.5 9.5l-2.1 2.1c.39.73.6 1.56.6 2.4 0 2.76-2.24 5-5 5-.84 0-1.67-.21-2.4-.6L12.5 20c1.14.63 2.45 1 3.84 1 1.16 0 2.26-.27 3.24-.75l3.02 3.02 1.4-1.4-3.02-3.02c.48-.98.75-2.08.75-3.24 0-1.39-.37-2.7-1-3.84l1.77-1.77z"
        fill="#E8531A"
      />
    </svg>
  );
}
